export const getFutuSymbol = () => {
  if (typeof window !== 'undefined') {
    const storedData = window.localStorage.getItem('futuSymbol')
    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData)
        return parsedData.state.futuSymbol
      } catch (e) {
        return 'BTCUSDT'
      }
    }
  }
  return 'BTCUSDT'
}

export const getFutuInterval = () => {
  if (typeof window !== 'undefined') {
    const storedData = window.localStorage.getItem('futuSymbol')
    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData)
        return parsedData.state.interval
      } catch (e) {
        return '1h'
      }
    }
  }
  return '1h'
}
